import includes from 'lodash/includes'

import { TagName } from '../constants/types/post'

import { checkTagCompatible } from './regExp'
// import nlp from 'compromise'

export const FORBIDDEN_CHARS = [
  '/',
  '\\',
  '?',
  '&',
  '=',
  '.',
  ',',
  '"',
  ':',
  '(',
  ')',
]

export const capitalizeFirstLetter = (value?: string): string => {
  if (value && typeof value === 'string') {
    return value.charAt(0).toUpperCase() + value.slice(1)
  } else {
    return value || ''
  }
}

export const removePlural = (str: string): string => {
  let modfiedString = str?.trim()
  if (str && typeof str === 'string') {
    modfiedString = str
      .replace(`'s`, ' ')
      .replace(`'s`, ' ')
      .replace(`'s`, ' ')
      .replace('`', '')
      .replace('`', '')
      .replace(`'`, '')
      .replace(`'`, '')
      .replace(`'`, '')
      .replace(`'`, '') // Bloody buggers
      .trim()
    return modfiedString
  } else {
    return ''
  }
}

// const modifiedString = title
//   .replace(/\([^()]*\)/g, '') // Replace everything within parentheses
//   .replace(/\|/g, '-') // Replace pipes with dashes
//   .replace(/–/g, '-') // Replace special dash character with normal dash
//   .replace(/-{2,}/g, '-') // Remove consecutive dashes

export function startsWithCapital(word: string) {
  return /[A-Z]/.test(word.charAt(0))
}

export function startsWithCapitalOnly(word: string) {
  // Tests if word only has capital, and the rest is small
  const startsWithCap = startsWithCapital(word)
  if (startsWithCap) {
    const letterArray: boolean[] = []
    word.split('').map((letter, idx) => {
      if (idx === 0) {
        // Pretend that the first letter isn't capital
        letterArray[idx] = false
      } else {
        letterArray[idx] = startsWithCapital(letter)
      }
    })
    const anyCap = letterArray.some((e) =>
      e === true)

    if (anyCap) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

export function isWordExcluded(word: string) {
  const excludedWords = [
    // English
    'a',
    'is',
    'be',
    'of',
    'so',
    'do',
    'to',
    'in',
    'and',
    'the',
    'was',
    'for',

    // Dutch
    'de',
    'en',
    'een',
    'het',
    'met',
    'dan',
    'van',
    'zal',
    'zou',
    'voor',
    'zijn',
    'daar',
    'hier',
    'toen',
  ]
  return includes(excludedWords, word.toLowerCase())
}

export function getTagsFromText(text: string): TagName[] {
  // TODO: Also get tags from tld, hash and query
  const tags: TagName[] = []
  const split = text.split(' ')
  // TODO: Also make heuristic compound-words from each even and uneven word-pairs, perhaps even with three words at the very end of the list? BUT make seperate function for exclusive use in autocomplete
  split.forEach((tagName) => {
    if (checkTagCompatible().test(tagName) && !isWordExcluded(tagName)) {
      for (const char of FORBIDDEN_CHARS) {
        tagName = tagName.split(char).join('')
      }
      // Any word that only starts with a capital letter gets lowercased
      tagName = startsWithCapitalOnly(tagName) ? tagName.toLowerCase() : tagName
      tags.push(tagName as TagName)
    }
  })
  return tags
}

// Compromise.js
/* eslint @typescript-eslint/no-unsafe-member-access: 0 */
/* eslint @typescript-eslint/no-unsafe-call: 0 */

// export function getNouns(sentence: string) {
//   const docData = nlp(sentence)
//   const nouns = docData.match('#Noun')
//   const nounsArray = nouns.map(d => {
//     return d.text('reduced') //return strings instead
//   })
//   return nounsArray
// }

// export function getAdjectives(sentence: string) {
//   const docData = nlp(sentence)
//   const adj = docData.nouns().adjectives().out('array')
//   return adj
// }

// export function getTerms(sentence: string) {
//   const docData = nlp(sentence)
//   const terms = docData.terms()
//   const termsArray = terms.map(d => {
//     return d.text('reduced') //return strings instead
//   })
//   return termsArray
// }

// export function getConjunctions(sentence: string) {
//   const docData = nlp(sentence)
//   const con = docData.match('#Conjunction').text()
//   // @ts-ignore because it exists
//   const left = docData.match(con).lookBehind('#Noun$').text()
//   // @ts-ignore because it exists
//   const right = docData.match(con).lookAhead('^#Noun').text()
//   return [left, right]
// }

// export function getValues(sentence: string) {
//   const docData = nlp(sentence)
//   // @ts-ignore because it exists
//   const nums = docData.values()
//   return nums.out('array')
// }

// export function toNumbers(sentence: string) {
//   const docData = nlp(sentence)
//   docData.numbers().toNumber()
//   return docData.text()
// }

// export function getPeople(sentence: string) {
//   const docData = nlp(sentence)
//   const ppl = docData.people()
//   return ppl.text()
// }
